// VFX: Morph Color Transition
// Category: morph-transition · Tags: transition, morph, color, smooth, mode-a
// Container mantém forma mas muda de cor suavemente. Red → Green clássico.
import { AbsoluteFill, useCurrentFrame, interpolate, Easing, interpolateColors } from "remotion";
import React from "react";

const clamp = { extrapolateLeft: "clamp", extrapolateRight: "clamp" } as const;

export interface MorphColorTransitionProps {
  fromColor?: string;
  toColor?: string;
  duration?: number;
  shape?: "card" | "circle" | "full";
  delay?: number;
}

export default function MorphColorTransition({
  fromColor = "#ef4444",
  toColor = "#10b981",
  duration = 15,
  shape = "card",
  delay = 0,
}: MorphColorTransitionProps) {
  const frame = useCurrentFrame();
  const t = interpolate(frame, [delay, delay + duration], [0, 1], { ...clamp, easing: Easing.inOut(Easing.cubic) });
  const color = interpolateColors(t, [0, 1], [fromColor, toColor]);
  const glow = `0 0 40px ${color}66, 0 0 80px ${color}33`;
  if (shape === "full") return <AbsoluteFill style={{ background: color }} />;
  if (shape === "circle")
    return (
      <AbsoluteFill style={{ justifyContent: "center", alignItems: "center", background: "#0a0e1a" }}>
        <div style={{ width: 240, height: 240, borderRadius: "50%", background: color, boxShadow: glow }} />
      </AbsoluteFill>
    );
  return (
    <AbsoluteFill style={{ justifyContent: "center", alignItems: "center", background: "#0a0e1a" }}>
      <div style={{ width: 580, height: 320, borderRadius: 20, background: `${color}22`, border: `1.5px solid ${color}88`, boxShadow: `0 2px 4px rgba(0,0,0,0.5), 0 8px 24px rgba(0,0,0,0.3), ${glow}`, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ fontSize: 20, fontWeight: 700, fontFamily: "system-ui", color, letterSpacing: "2px", textTransform: "uppercase", opacity: 0.85 }}>
          {t < 0.5 ? "⚠ PROBLEMA" : "✓ SOLUÇÃO"}
        </div>
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
